import { redirect, type ParsedLocation } from '@tanstack/react-router';

/** Where a visitor was heading, if it is a path on this origin. Anyone can
 * write this value into a link, so nothing else counts. */
export function carriedDestination(value: unknown): string | undefined {
  if (typeof value !== 'string' || !value.startsWith('/')) return undefined;
  const { origin } = window.location;
  try {
    const url = new URL(value, origin);
    const path = url.pathname + url.search + url.hash;
    // Checked as written and as returned: "/x/..//host" is on this origin, but
    // it normalizes to "//host", which is not.
    return url.origin === origin && new URL(path, origin).origin === origin ? path : undefined;
  } catch {
    return undefined;
  }
}

/** The key is Clerk's own name, so Clerk keeps it across its sign-in steps.
 * Always return it: an omitted key keeps its raw value from the address. */
export const destinationSearch = ({
  redirect_url,
}: Record<string, unknown>): { redirect_url?: string } => ({
  redirect_url: carriedDestination(redirect_url),
});

export const returningTo = (location: ParsedLocation) => ({
  redirect_url: location.href === '/' ? undefined : location.href,
});

/** The empty splat names /sign-in itself. Left out, the router reuses the
 * splat of the address being left. */
export const toSignIn = (location: ParsedLocation) =>
  redirect({
    to: '/sign-in/$',
    params: { _splat: '' },
    search: returningTo(location),
    replace: true,
  });
